<template>
  <div class="post-content">
    <div class="row row--flex">
      <div class="col-70">
        <p>Pytanie o nakład druku, niezależnie od jego formy, powinniśmy postawić sobie już na samym początku projektu. To on często zdeterminuje technologię, w której możemy wykonać naszą pracę. Podstawowym rozróżnieniem jest podział na druk cyfrowy i offsetowy. Przyjęło się uważać, że druk cyfrowy jest ekonomiczny w mniejszym nakładzie, do maksymalnie 500 egzemplarzy, a offsetowy – od tego pułapu, a często już przy 300 sztukach (to także zależy od formatu wydruku). To, co wpływa na koszta w procesie offsetowym, to przygotowanie druku i niezbędny dodatkowy nakład papieru na rozruch maszyny.</p>
      </div>
      <Sidenote class="col-30">
        <p>W tym dziale zajmujemy się drukiem cyfrowym i offsetowym na arkuszach.</p>
      </Sidenote>
    </div>
    <div class="row row--flex">
      <div class="col-70">
        <p
          class="indend-left highlighted-text"
        >Przy wyborze technologii należy wziąć także pod uwagę podłoże (nie każde jest odpowiednie do druku cyfrowego) oraz pożądany rezultat wydruku (druk offsetowy będzie zazwyczaj bardziej recyzyjny niż cyfrowy).</p>
      </div>
    </div>
    <div class="row row--flex">
      <div class="col-70">
        <p>Gdy te ograniczenia nas nie dotyczą, kluczowe są kolory oraz nakład. W przypadku koloru sytuacja jest prosta. Jeśli druk ma zawierać kolor dodatkowy Pantone metalizowany lub fluoresencyjny czy pastelowy, pozostaje nam druk offsetowy z dodatkowym kolorem Pantone. Pantone to system identyfikacji kolorów. Pozwala na bardzo precyzyjne określenie koloru (wybieranego z próbnika), a także druk kolorami niestandardowymi, takimi jak kolory fluorescencyjne, pastelowe czy metalizowane.</p>
      </div>
    </div>
    <div class="row">
      <div class="col-70">
        <p>W realizacji, w której zależy nam na uzyskaniu koloru Pantone (nie z palety metallic, fluo, pastele), możemy spróbować symulacji koloru Pantone przy wydruku cyfrowym. Takie możliwości daje nam wiele dostępnych na rynku maszyn cyfrowych. Tu kluczowy jest kontakt z drukarzem i ustalenie pożądanego efektu. Po wydruku próbnym i spasowaniu jego efektu z wzornikiem, nie będziemy mieć wątpliwości czy operacja się powiodła.</p>
      </div>
    </div>
    <div class="row">
      <div class="col-70">
        <p>
          Druk cyfrowy daje nam wiele możliwości, w tym – wydruk referencyjny jednego egzemplarza materiału. Wydruk próbny jest także jak najbardziej możliwy przy wydruku offsetowym, wiąże się jednak z dodatkowymi kosztami przygotowania płyt drukarskich.
          <span
            class="text-background"
          >Warto wspomnieć również o tym, że w wypadku druków offsetowych, maszyna „rozpędza się” zanim może zacząć drukować poprawnie, co powoduje zużycie prądu oraz stratę na próbnych arkuszach. Jest to nieuniknione, ale może być dodatkowym argumentem za drukiem cyfrowym</span>, jeśli chcemy drukować w możliwie zrównoważony sposób. Z drugiej strony – wydruk offsetowy lepiej poddaje się recyklingowi, szczególnie w porównaniu do druku cyfrowego suchotonerowego.
        </p>
      </div>
    </div>
    <div class="row">
      <div class="col-70">
        <p>W tym dziale zajmujemy się drukiem cyfrowym i offsetowym na arkuszach. W przypadku druku wielkoformatowego chciałabym zwrócić uwagę przede wszystkim na wybór podłoża. Wydruk – w przypadku druku wielkoformatowego mamy do dyspozycji druk UV, lateksowy oraz (wyjątkowo szkodliwy) twardy solwent – jest szczególnie wątpliwy etycznie ze względu na wybierane podłoża, np. płótno banerowe z PCV. Utrwalacze stosowane przy nadruku (który powinien być przecież trwały!) w kombinacji z podłożem dają wysoce nierecyklingowalny, szkodliwy odpad. W przypadku, gdy taka produkcja jest niezbędna, możemy wybrać ekologiczny baner bez PCV, podlegający recyklingowi (np. Terra Banner z oferty Endutex). Warto uzgodnić na wstępie ze zleceniodawcą, co wydarzy się z banerami po ich zdjęciu – mogą posłużyć np. jako ocieplenie bud w schroniskach dla zwierząt albo zostać poddane upcyklingowi, np. w produkcji toreb promocyjnych (rozwiązanie często stosowane na festiwalach).</p>
      </div>
    </div>
    <div class="row">
      <div class="col-70">
        <p class="heading--sans-serif">DRUKI JEDNORAZOWE</p>
        <p>Nie zawsze jesteśmy w stanie idealnie oszacować optymalny nakład danego druku. Szczególnie trudno jest to przewidzieć przy drukach jednorazowych – zaproszeniach, ulotkach, broszurkach, programach jednodniowych wydarzeń. Jeśli nie potrafisz ocenić potencjalnej użyteczności wydruku lub przewidzieć dystrybucji oraz zużycia materiałów, dobrym rozwiązaniem jest print-on-demand, czyli zamawianie druków w trybie bieżącym, zgodnie z zapotrzebowaniem. W pierwszej kolejności drukujesz nakład, co do którego jesteś pewien, że zostanie dobrze rozdystrybuowany, zwiększony o 15%. Kiedy nakład wyjściowy się skończy, jesteś w stanie oszacować w czasie kolejne zapotrzebowanie. Możesz przed dodrukiem nanieść zmiany w materiałach, uzupełnić je lub skrócić.</p>
      </div>
    </div>
    <div class="row">
      <div class="col-70">
        <p
          class="indend-left highlighted-text"
        >Lęk przed niedoszacowaniem liczby potrzebnych materiałów jest zazwyczaj nieadekwatny do rzeczywistości. Przypomnij sobie dowolne wydarzenie / konferencję, na której byłeś. Czy kiedykolwiek miałeś wrażenie, że zabrakło na niej programów lub innych druków ulotnych? A może wystarczy aktualna informacja na tablicach w miejscu wydarzenia oraz komunikacja online?</p>
      </div>
    </div>
    <div class="row">
      <div class="col-70">
        <p>Jeśli wiesz, że nie rozdasz 150 zaproszeń na swoje wydarzenie, wydrukuj 80. Co do zasady – zaproszeń raczej nigdy nie brakuje. Jeśli reklamujesz wydarzenie w danym mieście, postaraj się o większą dystrybucję plakatów, a mniejszą ulotek. Mają szansę być zauważone przez więcej osób, bez zaśmiecania miasta (mowa tu rzecz jasna o plakatach w legalnych miejscach dystrybucji).</p>
      </div>
    </div>
    <div class="row row--flex row--flex-wrap">
      <div class="col-70">
        <p class="heading--sans-serif">DRUKI DŁUGODYSTANSOWE</p>
        <p>W przypadku druków trwałych, które nie są związane z danym wydarzeniem czy krótkim sezonem, rozważny jest druk w dużym nakładzie. Jeśli masz pewność, że z danego opracowania (broszura, katalog, materiały szkoleniowe) będziesz korzystać w niezmienionej formie przez następne miesiące czy nawet lata, wyprodukuj większy nakład w druku offsetowym. Ma to sens zarówno z ekologicznego, jak i ekonomicznego punktu widzenia.</p>
      </div>
      <div class="col-30 related-news-col">
        <RelatedPosts :currentPostID="postID" />
      </div>
      <div class="col-70" style="margin-top: 25px;">
        <p>Przy większym nakładzie wybieramy zazwyczaj druk offsetowy. Tutaj znów warto zwrócić uwagę na to, że maszyna offsetowa potrzebuje „rozbiegu” zanim zacznie drukować. Dla przykładu, przy średniej klasy maszynie offsetowej, 1000 arkuszy drukuje się ok. 20 min. Sam „przyrząd” maszyny, czyli przygotowanie do druku to ok. godzina – pracy drukarza, zużycia prądu oraz papieru testowego.</p>
      </div>
    </div>
    <ScrollToTop />
  </div>
</template>

<script>
import RelatedPosts from "../RelatedPosts";
import ScrollToTop from "../ScrollToTop";
import Sidenote from "../Sidenote";

export default {
  name: "Post2",
  components: {
    RelatedPosts,
    ScrollToTop,
    Sidenote
  },
  props: {
    postID: Number
  }
};
</script>

<style lang="scss" scoped>
@media (min-width: $tablet + 1) {
  .related-news {
    position: absolute;
    top: 0;
    right: 0;
    width: 100%;
  }
  .related-news-col {
    position: relative;
  }
}
</style>